var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>HTG0</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>HTG1</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>HTG2</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>HTG3</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>HTG4</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>HTG5</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-one">'+
                        '<ul>'+
                            '<li>HTG6</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="HTG 0" data-betCode="410" class="bet-choose" data-odd="'+quotes.Home0+'">'+globalFunctions.checkQuotes(quotes.Home0)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="HTG 1" data-betCode="411" class="bet-choose" data-odd="'+quotes.Home1+'">'+globalFunctions.checkQuotes(quotes.Home1)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="HTG 2" data-betCode="412" class="bet-choose" data-odd="'+quotes.Home2+'">'+globalFunctions.checkQuotes(quotes.Home2)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="HTG 3" data-betCode="413" class="bet-choose" data-odd="'+quotes.Home3+'">'+globalFunctions.checkQuotes(quotes.Home3)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="HTG 4" data-betCode="414" class="bet-choose" data-odd="'+quotes.Home4+'">'+globalFunctions.checkQuotes(quotes.Home4)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="HTG 5" data-betCode="415" class="bet-choose" data-odd="'+quotes.Home5+'">'+globalFunctions.checkQuotes(quotes.Home5)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-one">'+
                            '<ul>'+
                                '<li data-betType="HTG 6" data-betCode="416" class="bet-choose" data-odd="'+quotes.Home6+'">'+globalFunctions.checkQuotes(quotes.Home6)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/home_goals.js
// module id = 2012
// module chunks = 4